<adapt-dialog [maxWidth]="800">
    <h3 adapt-dialog-title>{{ isEditing ? "Edit" : "Add" }} approved client</h3>

    <ng-container adapt-dialog-content>
        @if (savedClient) {
            <div class="alert alert-success">Client saved. You can copy the secret now or view it again when editing this client.</div>
            <label class="form-label"
                   for="mcpOAuthClientSecret">Client secret</label>
            <input id="mcpOAuthClientSecret"
                   class="form-control"
                   readonly
                   [value]="savedClient.ClientSecret" />
        } @else {
            <div class="mb-3">
                <label class="form-label"
                       for="mcpOAuthClientId">Client ID</label>
                <input id="mcpOAuthClientId"
                       class="form-control"
                       maxlength="100"
                       [(ngModel)]="clientId"
                       [disabled]="isEditing" />
                <div class="form-text">The client ID cannot be changed after the client is added.</div>
            </div>

            <div class="mb-3">
                <label class="form-label"
                       for="mcpOAuthClientName">Client name</label>
                <input #focus
                       id="mcpOAuthClientName"
                       class="form-control"
                       maxlength="200"
                       [(ngModel)]="displayName" />
            </div>

            <div class="mb-3">
                <label class="form-label"
                       for="mcpOAuthRedirectUris">Redirect URIs</label>
                <textarea id="mcpOAuthRedirectUris"
                          class="form-control"
                          rows="5"
                          [(ngModel)]="redirectUris"></textarea>
                <div class="form-text">Enter one unique HTTPS or loopback HTTP URI per line.</div>
            </div>

            @if (isConfidential) {
                <div class="mb-3">
                    <label class="form-label"
                           for="mcpOAuthExistingClientSecret">Current client secret</label>
                    @if (loadingClientSecret) {
                        <div role="status">Loading client secret...</div>
                    } @else if (clientSecretError) {
                        <div class="text-danger" role="alert">Unable to load the client secret: {{ clientSecretError }}</div>
                    } @else if (existingClientSecret) {
                        <input id="mcpOAuthExistingClientSecret"
                               class="form-control"
                               readonly
                               [value]="existingClientSecret" />
                        <div class="form-text">Viewing or copying this secret does not replace it.</div>
                    } @else {
                        <div class="form-text">This secret is not available for display. Older secrets were stored only as hashes.
                            The existing secret remains valid; you do not need to replace it to save other changes.</div>
                    }
                </div>
            }

            <div class="mb-3">
                <label class="form-check-label d-flex align-items-center gap-2">
                    <input type="checkbox"
                           class="form-check-input mt-0"
                           [(ngModel)]="generateClientSecret" />
                    <span>{{ isConfidential ? "Generate a replacement client secret" : "Generate a client secret (confidential client)" }}</span>
                </label>
                <div class="form-text">
                    @if (isConfidential) {
                        Generating a replacement immediately invalidates the previous secret. Update the connected app after saving.
                    } @else {
                        Enable for server applications that require a client secret, such as Microsoft 365 Copilot.
                    }
                    PKCE remains required.
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <label class="form-label"
                           for="mcpOAuthGrantTypes">Grant types</label>
                    <input id="mcpOAuthGrantTypes"
                           class="form-control"
                           [value]="grantTypes"
                           disabled />
                </div>
                <div class="col-md-4">
                    <label class="form-label"
                           for="mcpOAuthResponseTypes">Response types</label>
                    <input id="mcpOAuthResponseTypes"
                           class="form-control"
                           [value]="responseTypes"
                           disabled />
                </div>
                <div class="col-md-4">
                    <label class="form-label"
                           for="mcpOAuthTokenEndpointAuthMethod">Token endpoint auth method</label>
                    <input id="mcpOAuthTokenEndpointAuthMethod"
                           class="form-control"
                           [value]="tokenEndpointAuthMethod"
                           disabled />
                </div>
            </div>
        }
    </ng-container>

    <div adapt-dialog-footer
         adaptBlockingButtonGroup>
        @if (savedClient) {
            <button adaptButton="primary"
                    (click)="finish()">Done</button>
        } @else {
            <button adaptButton="primary"
                    [adaptBlockingClick]="saveClient">{{ isEditing ? "Save client" : "Add client" }}</button>
            <button adaptButton="cancel"
                    (click)="cancel()"></button>
        }
    </div>
</adapt-dialog>
